const config = {
  
      backendURL: "https://node-backend.kafi-shop.ch",
  
      cors: "https://node-backend.kafi-shop.ch",
  
  }

  export default config;